"use client";

import { useEffect, useState } from "react";
import styles from "./transfer-section.module.scss";

import { useConfig } from "wagmi";
import BridgeLoader from "@/features/bridge/components/bridge-loader";
import TokenSelectors from "@/features/bridge/components/token-selector/token-selector";
import ChainCard from "@/features/bridge/components/transfer/chain-card";
import ProcessLine from "@/features/bridge/components/transfer/process-line";
import SwapButton from "@/features/bridge/components/transfer/swap-button";

const TransferTool = () => {
  const [loading, setLoading] = useState(true);
  const config = useConfig();

  useEffect(() => {
    config.chains.map((chain) => chain.id);
  }, [config.chains]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 200);
  }, []);

  if (loading) {
    return <BridgeLoader />;
  } else {
    return (
      <div className={styles.transferSection}>
        <ProcessLine />
        <div className={styles.cards}>
          <ChainCard chainOrigin />
          <SwapButton />
          <ChainCard />
        </div>
        <TokenSelectors />
      </div>
    );
  }
};

export default TransferTool;
